<section class="flex justify-content-center wrapper mb-5 mt-4">
    <div class="wrapper-content flex-column xl:flex-row">
        <div class="app-card h-full col-12 px-0">
            <app-form-viewer [onSubmitForm]="onSubmitForm"></app-form-viewer>
        </div>
    </div>
</section>

<app-procesar-tramite></app-procesar-tramite>
